import dynamic from 'next/dynamic';

import type {
  DrupalBlock,
  DrupalImage as DrupalImageType,
  DrupalLink,
} from '@commons/types/drupal';

/**
 * Lazy loading the component to reduce the initial bundle size.
 *
 * This does not work when used in a pagebuilder factory directly, because every items are loaded at once.
 * Doing it in the component itself ensures that the chunks are only loaded when the component is rendered.
 *
 * @see https://nextjs.org/docs/app/building-your-application/optimizing/lazy-loading
 */

const ScrollableSlide = dynamic(() => import('./ScrollableSlide'));

/**
 * Type definition for the ScrollableSlideBlock component properties.
 */

export type ScrollableSlideProps = DrupalBlock<{
  body: string;
  backgroundImage: DrupalImageType;
  link?: DrupalLink;
  id?: string;
  linkType: 'default' | 'webform';
  linkText?: string;
}>;

/**
 * ScrollableSlideBlock component.
 *
 * Act as a wrapper to ensure the dynamic import is only done when the component is rendered.
 */

const ScrollableSlideBlock = (props: ScrollableSlideProps) => <ScrollableSlide {...props} />;

/**
 * This block uses GSAP ScrollTrigger, so we disable the default animation.
 */

ScrollableSlideBlock.supportsAnimation = false;

export default ScrollableSlideBlock;
